<template>
	<div id="app" :class="vueAppClasses">
    <ion-app>
      <offline @detected-condition="handleConnectivityChange"></offline>
      <vs-row class="w-full update-available bg-warning" v-if="showUpgradeUI.active" vs-justify="center" vs-align="center">
        <vs-col class="text-center">
          We've finetuned application in the background. Please reload to activate new features. <vs-button type="filled" color="primary" @click="accept" size="small">Reload</vs-button>
        </vs-col>
      </vs-row>
      <router-view @setAppClasses="setAppClasses"></router-view>
    </ion-app>
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import offline from 'v-offline';

import { StatusBar } from '@ionic-native/status-bar'
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';

export default {
  components: {
    offline,
  },
  data: () => {
    return  {
      vueAppClasses: [],
      showUpgradeUI: {
        active: false,
        data: null,
      },
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    },
    '$store.state.auth.userRole'(val) {
      this.$acl.change(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    },
    '$route'() {
      let ion_content = document.querySelector('ion-content')
      if (ion_content) ion_content.scrollToTop()
    },
  },
  computed: {
    cloud: () => faCloudUploadAlt,
  },
  created() {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    window.addEventListener("swRegistered", (e) => {
      console.log(e)
      this.$store.dispatch('updateServiceWorker', e.detail.registration)
    })
    window.addEventListener("swUpdateAvailable", (e) => {
      this.showUpgradeUI.active = true
      this.showUpgradeUI.data = e.detail.worker
    })
    StatusBar.backgroundColorByHexString('#ffffff')
    StatusBar.styleDefault()
  },
  methods: {
    handleConnectivityChange(status){
      this.$store.dispatch("updateConnectivityStatus", status)
    },
    accept() {
      this.showUpgradeUI.data.postMessage({type: 'SKIP_WAITING'})
    },
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
      }
    },
    handleWindowResize(event) {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleScroll () {
      // this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.dispatch('updateWindowWidth', window.innerWidth)
    this.handleConnectivityChange(navigator.onLine)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    // this.$nextTick(() => {
    //   window.addEventListener('resize', this.handleWindowResize);
    // });
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>

<style lang="scss">
.update-available {
  position: fixed;
  bottom: 0;
  height: 60px;
  color: #fff;
  font-weight: 700;
  z-index: 999999;
}
.vs-input--label{ font-weight: 600 !important; font-size: .95rem !important; line-height:32px !important;
  padding-left: 0 !important;
}
.vdp-datepicker__calendar {
  z-index: 500!important;
}
.icon-button {
  padding: 0.5rem !important;
}
.con-vs-tooltip {
  display: inline-block;
}
.vs-input--input, .vs-button, .vs-textarea,
.vs__dropdown-toggle {
  border-radius: 0!important;
}

.ion-page {
  contain: size style !important;

  overflow: auto !important;
  justify-content: flex-start !important;
}
body {
  background: #fff !important;
}
.vs-popup--content {
  overflow: unset !important;
}

.freeze_row {
  .vs-table--tbody {
    overflow-y: scroll;
    max-height: 600px;
  }
}

.freeze_row.row1 tr:nth-child(1) {
  position: sticky;
  opacity: 1 !important;
  z-index: 1000;
  top: 0;
}
.freeze_row.row2 tr:nth-child(2) {
  position: sticky;
  opacity: 1 !important;
  z-index: 1000;
  top: 0;
}

.freeze_row.row3 tr:nth-child(3) {
  position: sticky;
  opacity: 1 !important;
  z-index: 1000;
  top: 10.8%;
}

.freeze_row.row3_top_diff tr:nth-child(3) {
  position: sticky;
  opacity: 1 !important;
  z-index: 1000;
  top: 7.5%;
}

.sync-popup {
  .vs-popup--title {
    display: none;
  }
  .vs-popup--close {
    position: absolute;
    right: 0;
    top: 5px;
  }
}

// dashboard common styles
.fix-filters {
    position: sticky; 
    top: 10.5vh; 
    padding: 5px; 
    opacity: 1; 
    z-index: 2500;
    .vx-card {
      box-shadow: 0 0 10px #CDCDCD;
    }
}

@media screen and (min-width: 769px) and (max-width: 1300px) {
  .fix-filters {
    top: 8.5vh;
  }
}

@media screen and (min-width: 1300px){
  .fix-filters {
    top: 10.5vh;
  }
}

.count-title {
  display: inline-block;
  margin: 0 0 0 16px;
  color: #222;
  font-weight: 500;
}

.counts-small {
  margin: 0 !important;
  width: auto;
  text-align: center;
  background: #ffeae3;
  padding: 10px 10px;
  border-radius: 1.5rem;
}

.txt-color {
  color: rgba(var(--vs-primary),1)!important; 
  font-weight: 600 !important;
}

.align-items-center {
  align-items: center;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.vs-tabs-primary .activeChild button, .vs-tabs-primary button.vs-button-filled:not(:disabled):hover {
  color: rgba(255, 255, 255, 1)!important;
}
</style>
